/*
 * @Auther: 罗耀祖
 * @Date: 2022-02-16 15:23:02
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-05-17 10:35:47
 * @name: 我的售后配置
 * @Description: 我的售后配置
 * @FilePath: \project\src\config\afterSale.config.js
 * @Author: desktop
 */
export const afterSale_acts = [
  {
    key: 'fangan', //标识
    act_text: '填写售后方案', //动作名称
    statusText: '需填写售后方案', //状态文字
    path: '/waitApproveDeal', //跳转路径
  },
  {
    key: 'jichu',
    act_text: '寄出',
    statusText: '',
    path: '',
  },
  {
    key: 'dingjia',
    act_text: '定价',
    statusText: '需定价',
    path: '/waitApproveDeal',
  },
  {
    key: 'cwdingjia',
    act_text: '财务定价',
    statusText: '需定价',
    path: '/waitApproveDeal',
  },
  {
    key: 'fukuan',
    act_text: '付款',
    statusText: '',
    path: '',
  },
  {
    key: 'fajiandizhi',
    act_text: '确认收件地址',
    statusText: '',
    path: '',
  },
  {
    key: 'shoujian',
    act_text: '收件',
    statusText: '',
    path: '',
  },
  {
    key: 'pingjia',
    act_text: '评价',
    statusText: '',
    path: '',
  },
  {
    key: 'shoukuan',
    act_text: '确认缴费',
    statusText: '用户已缴费,待确认',
    path: '/waitConfirmUserPay',
  },
  {
    key: 'shoudao',
    act_text: '确认收到用户寄件',
    statusText: '用户已寄件,待确认',
    path: '/waitConfirmLogistics',
  },
  {
    key: 'shoudaoend',
    act_text: '确认收到用户寄件',
    statusText: '用户已寄件,待确认',
    path: '/waitConfirmLogistics',
  },
  {
    key: 'zhipaifajian',
    act_text: '指派发件人',
    statusText: '须指派发件人',
    path: '/waitDealReissueArrangement',
  },
  {
    key: 'fajian',
    act_text: '发件',
    statusText: '待发件',
    path: '/waitDealReissue',
  },
  {
    key: 'zhipai',
    act_text: '指派上门人',
    statusText: '须指派上门人',
    path: '/waitDealToDoorServiceArrangement',
  },
  {
    key: 'shangmen',
    act_text: '上门',
    statusText: '待上门',
    path: '/waitDealToDoorService',
  },
  {
    key: 'xufuzongshenpi',
    act_text: '审批',
    statusText: '待审批',
    path: '/waitApproveDeal',
  },
  {
    key: 'xuyingxiaozhuren',
    act_text: '审批',
    statusText: '待审批',
    path: '/waitApproveDeal',
  },
  {
    key: 'yingxiaozhurenshenpi',
    act_text: '审批',
    statusText: '待审批',
    path: '/waitApproveDeal',
  },
  {
    key: 'pinzhisp',
    act_text: '审批',
    statusText: '待审批',
    path: '/waitApproveDeal',
  },
];
export const afterSale_detail_btn = [
  {
    key: 'fangan',
    btn: [
      {
        type: 'reject',
        text: '拒绝',
        value: -1,
      },
      {
        type: 'resolve',
        text: '填写处理方案',
        value: '',
      }
    ]
  },
  {
    key: 'xuyingxiaozhuren',
    btn: [
      {
        type: 'reject',
        text: '拒绝',
        value: -1,
      },
      {
        type: 'resolve',
        text: '同意',
        value: 'OK',
      }
    ]
  },
  {
    key: 'yingxiaozhurenshenpi',
    btn: [
      {
        type: 'reject',
        text: '拒绝',
        value: -1,
      },
      {
        type: 'resolve',
        text: '同意',
        value: 'OK',
      }
    ]
  },
  {
    key: 'pinzhisp',
    btn: [
      {
        type: 'reject',
        text: '拒绝',
        value: -1,
      },
      {
        type: 'resolve',
        text: '确认',
        value: 'OK',
      }
    ]
  },
  {
    key: 'dingjia',
    btn: [
      {
        type: 'reject',
        text: '拒绝',
        value: -1,
      },
      {
        type: 'resolve',
        text: '填写定价',
        value: '',
      }
    ]
  },
  {
    key: 'cwdingjia',
    btn: [
      {
        type: 'reject',
        text: '拒绝',
        value: -1,
      },
      {
        type: 'resolve',
        text: '确认定价',
        value: '',
      }
    ]
  },
  {
    key: 'xufuzongshenpi',
    btn: [
      {
        type: 'reject',
        text: '拒绝',
        value: -1,
      },
      {
        type: 'resolve',
        text: '同意',
        value: 'OK',
      }
    ]
  },
  {
    key: 'sale_second_boss',
    btn: [
      {
        type: 'reject',
        text: '拒绝',
        value: -1,
      },
      {
        type: 'resolve',
        text: '同意',
        value: 'OK',
      }
    ]
  },
  {
    key: 'shoukuan',
    btn: [
      {
        type: 'reject',
        text: '拒绝',
        value: -1,
      },
      {
        type: 'resolve',
        text: '同意',
        value: 'OK',
      }
    ]
  },
  {
    key: 'shoudao',
    btn: [
      {
        type: 'reject',
        text: '拒绝',
        value: -1,
      },
      {
        type: 'resolve',
        text: '确认收货',
        value: '',
      }
    ]
  },
  {
    key: 'shoudaoend',
    btn: [
      {
        type: 'reject',
        text: '拒绝',
        value: -1,
      },
      {
        type: 'resolve',
        text: '确认收货',
        value: '',
      }
    ]
  },
  {
    key: 'zhipaifajian',
    btn: [
      {
        type: 'reject',
        text: '拒绝',
        value: -1,
      },
      {
        type: 'resolve',
        text: '提交',
        value: '',
      }
    ]
  },
  {
    key: 'fajian',
    btn: [
      {
        type: 'reject',
        text: '拒绝',
        value: -1,
      },
      {
        type: 'resolve',
        text: '提交',
        value: '',
      }
    ]
  },
  {
    key: 'zhipai',
    btn: [
      {
        type: 'reject',
        text: '拒绝',
        value: -1,
      },
      {
        type: 'resolve',
        text: '提交',
        value: '',
      }
    ]
  },
  {
    key: 'shangmen',
    btn: [
      {
        type: 'reject',
        text: '拒绝',
        value: -1,
      },
      {
        type: 'resolve',
        text: '确认上门',
        value: '',
      }
    ]
  },
  {
    key: '',
    btn: [
      {
        type: 'reject',
        text: '拒绝',
        value: -1,
      },
      {
        type: 'resolve',
        text: '同意',
        value: 'OK',
      }
    ]
  }
];
export const afterSale_successStatus = [
  {
    text: '已审批',
    value: ['fangan', 'xuyingxiaozhuren', 'xufuzongshenpi', 'pinzhisp', ''],
  },
  {
    text: '已确认',
    value: ['shoudao', 'shoukuan'],
  },
  {
    text: '已处理',
    // 其余为已处理
  },
]

//部门
export const departments = [
  {
    name: 'a',
    text: '生产部',
    value: 1,
  },
  {
    name: 'b',
    text: '技术部',
    value: 0,
  },
  {
    name: 'c',
    text: '销售部',
    value: 1,
  },
  {
    name: 'd',
    text: '计划部',
    value: 1,
  },
  {
    name: 'e',
    text: '物控部',
    value: 1,
  },
  {
    name: 'f',
    text: '三角琴总装',
    value: 0,
  },
  {
    name: 'g',
    text: '三角琴码克',
    value: 0,
  },
  {
    name: 'h',
    text: '立式琴总装',
    value: 0,
  },
  {
    name: 'i',
    text: '码克车间',
    value: 0,
  },
  {
    name: 'j',
    text: '背架车间',
    value: 0,
  },
  {
    name: 'k',
    text: '铁板车间',
    value: 0,
  },
  {
    name: 'l',
    text: '成品仓库',
    value: 1,
  },
  {
    name: 'm',
    text: '半成品',
    value: 0,
  },
  {
    name: 'n',
    text: '外协',
    value: 0,
  },
  {
    name: 'o',
    text: '五金分厂',
    value: 0,
  },
  {
    name: 'p',
    text: '抛光车间',
    value: 0,
  },
  {
    name: 'q',
    text: '财务',
    value: 0,
  },
  {
    name: 'r',
    text: '琴凳',
    value: 0,
  },
  {
    name: 's',
    text: '出货检验',
    value: 0,
  },
  {
    name: 't',
    text: '仓库财务',
    value: 1,
  },
  {
    name: 'u',
    text: '采购',
    value: 1,
  },
  {
    name: 'v',
    text: '琴弦车间',
    value: 0,
  },
  {
    name: 'w',
    text: '立式琴外壳',
    value: 0,
  },
  {
    name: 'x',
    text: '返修工段',
    value: 0,
  },
];
// 处理意见模板
export const deal_notice_template = [
  {
    label: '无需模板',
    value: '',
  },
  {
    label: '立式琴货损模板',
    value: `1.钢琴纸箱、底板、琴凳纸箱报废。\n2.报废顶盖、顶盖铰链、顶覆呢。\n3.背架脏（背架整体打磨刷漆)。\n4.从调音到打包重做。（按新琴标准返修入库）\n5.琴凳退琴凳车间返修并检验合格后入库。\n6.成本核算。`,
  },
  {
    label: '立式琴配件补发模板',
    value: `1.新领一块120K/10#CH的前键盖，按退回尺寸打孔、装配、抛光好后还给客户。\n2.退回的前键盖报废。`,
  },
  {
    label: '立式琴弦轴生锈模板',
    value: `1.整琴报废，除外壳、击弦机、键盘、榔头、铁板、背架框可用。\n2.报废：前后顶盖、上下背覆板。拆左右侧板时尽量保护。\n3.码克车间拆铁板，铁板送铁板车间打磨至底漆后重新喷金粉、面漆。\n4.需拔掉挂弦钉及弦枕钉且报废，重新铰孔、栽钉（更换铁板号）。\n5.背架送背架车间更换长短码、弦轴板及垫板且报废，码钉报废。\n6.如在拆除过程中背架有损坏的，背架车间需修理好。\n7.可用部件另行配料，铁板、背架返修好后还仓库。\n8.琴凳退琴凳车间返修并检验合格后入库。`,
  },
  {
    label: '琴凳补发模板',
    value: `1.琴凳纸箱报废，琴凳退琴凳车间返修并检验合格后入库。\n2.补发XD-24/10# 琴凳1只给客户（已补发，补单据）。`,
  },
  {
    label: '三角琴返修模板',
    value: `1.整琴油漆面发黄；铁板油漆轻微变色；键面划伤；传动系统木块发霉。（做借用琴使用，暂不修）。\n2.选择延音连接杆断（报废）。琴腿矮肩开裂（琴腿矮肩车间修补使用）。\n3.调音四、出厂整理、止音器精整、调节踏瓣行程、油漆整理、抛光按返包计件。\n4.琴凳退琴凳车间返修并检验合格后入库。`,
  },
  {
    label: '三角琴配件补发模板',
    value: `1.定位尺木质开裂（报废）。（谱架定位尺客户已付款购买）\n2.重新装配定位尺、贴皮、抛光、打包还给客户。`,
  },
];